import * as React from 'react';
import {CustomButton} from '../reusableComponents/CustomButton';
import {TextInput} from '../reusableComponents/FormComponents/TextInput';
import {Icon} from '../reusableComponents/Icon';
import {PerfectScrollbar} from '../reusableComponents/PerfectScrollbar';
import {Select} from '../reusableComponents/FormComponents/Select';
import TagsInput from 'react-tagsinput';
import 'react-tagsinput/react-tagsinput.css';

export interface IQuestion {
    question?: string;
    Choices?: Array<string>;
    CorrectAnswer?: string;
}

export interface IQuestionsTableProps {
    defaultValue?: {
        questionNum?: number;
        Choices?: Array<string>;
        question?: string;
        CorrectAnswer?: string;
    }[];
}

export interface IQuestionsTableState {
    question: string;
    answer: string;
    Choices: Array<string>;
    questions: IQuestion[];
    isEdit: boolean;
    activeIndex: number;
}

export class QuestionsTable extends React.Component<IQuestionsTableProps, IQuestionsTableState> {
    constructor(props: IQuestionsTableProps) {
        super(props);
        this.state = {
            question: '', answer: '', Choices: [],
            questions: props.defaultValue || [], isEdit: false, activeIndex: null
        };
    }

    get questions() {
        return this.state.questions;
    }

    public saveQuestion = () => {
        if (!this.state.question || !this.state.answer || !this.state.Choices.length || this.state.Choices.length === 1) {
            return;
        }
        if (this.state.isEdit && this.state.activeIndex >= 0) {
            const filteredQuestions = this.state.questions;
            filteredQuestions[this.state.activeIndex] = {
                question: this.state.question,
                CorrectAnswer: this.state.answer,
                Choices: this.state.Choices
            };
            this.setState({
                questions: filteredQuestions,
                question: '',
                answer: '',
                Choices: [],
                isEdit: false,
                activeIndex: null
            });
            return;
        }
        const allQuestions = this.state.questions;
        allQuestions.push({
            question: this.state.question,
            Choices: this.state.Choices,
            CorrectAnswer: this.state.answer
        });
        this.setState({
            Choices: [],
            questions: allQuestions,
            question: '',
            answer: ''
        });
    }

    public handleQuestionEdit = (index) => {
        this.setState({
            question: this.state.questions[index].question,
            answer: this.state.questions[index].CorrectAnswer,
            Choices: this.state.questions[index].Choices || [],
            isEdit: true,
            activeIndex: index
        });
    }

    public handleQuestionDelete = (index) => {
        const filteredQuestions = this.state.questions.filter((Questions, i) => index !== i);
        this.setState({
            questions: filteredQuestions,
            question: '',
            Choices: [],
            answer: ''
        });
    }

    public renderQuestions = () => {
        return this.state.questions.length > 0 ? this.state.questions.map((ques, index) => {
            return <QuestionRow
                key={index}
                handleEdit={this.handleQuestionEdit}
                handleDelete={this.handleQuestionDelete}
                index={index}
                quesNum={index + 1}
                ques={ques.question}
                ans={ques.CorrectAnswer}
            />;
        }) : <span>No Questions Added</span>;
    }

    handleChange = (Choices) => {
        const removedCorrectAnswer = Choices.filter(ans => this.state.answer === ans);
        if (!Choices.length || !removedCorrectAnswer.length) {
            this.setState({answer: ''});
        }
        this.setState({Choices});
    }

    generatingCorrectAnswerSelectOptions = (opts) => {
        const options = [];
        opts.forEach(op => {
            options.push({value: op, label: op});
        });
        return options;
    }

    public render() {
        return <div className="question-table">
            <div className="title">Questions:</div>
            <div className="table-head">
                <div className="editable">
                    Edit/Delete
                </div>
                <div className="ques number">
                    #
                </div>
                <div className="ques question">
                    Question
                </div>
                <div className="ques answer">
                    Answer
                </div>
            </div>
            <PerfectScrollbar className="questions">
                {this.renderQuestions()}
            </PerfectScrollbar>
            <div className="question-input">
                <div className="question">
                    <div className="head">Question:</div>
                    <TextInput
                        hintText=""
                        id="link"
                        color="white"
                        type="text"
                        onChange={(e, value) => this.setState({
                            question: value
                        })}
                        value={this.state.question}
                    />
                </div>
                <div className="choices">
                    <div className="head">Choices:</div>
                    <TagsInput value={this.state.Choices} inputProps={{placeholder: this.state.Choices.length < 4 ? 'Add an answer' : ''}} addKeys={[9, 13]} onChange={this.handleChange} onlyUnique={true} maxTags={4}/>
                </div>
                <div className="answer">
                    <div className="head">Answer:</div>
                    <Select
                        menuItems={this.generatingCorrectAnswerSelectOptions(this.state.Choices)}
                        disabled={this.state.Choices.length === 0}
                        multiple={false}
                        color={'white'}
                        hintText=""
                        onChange={(e, value) => this.setState({
                            answer: value
                        })}
                        value={this.state.answer}
                    />
                </div>
                <div className="add-answer" onClick={this.saveQuestion}>
                    {/* <CustomButton type="button" onClick={this.saveQuestion} icon="plus" ><br />
                        {this.state.isEdit ? 'Update' : 'Add'}
                    </CustomButton> */}
                    <div><Icon icon="plus"/></div>
                    <div><label htmlFor="">{this.state.isEdit ? 'Update' : 'Add'}</label></div>
                </div>
            </div>
        </div>;
    }
}

const QuestionRow = ({quesNum, ques, ans, index, handleEdit, handleDelete}) => {
    return <div className="ques-row">
        <div className="options">
            <Icon icon="edit" onClick={() => handleEdit(index)}/>
            <Icon icon="trash" onClick={() => handleDelete(index)}/>
        </div>
        <div className="que-num">{quesNum}</div>
        <div className="question">{ques}</div>
        <div className="answer">{ans}</div>
    </div>;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/QuestionsTable.tsx